import styled from 'styled-components';
import Box from '..';

export const Col = styled(Box)`
  display: flex;
  flex-direction: column;
`;